// document.querySelectorAll('.hover-slider').forEach((slider) => {
//   const swiperInstance = new Swiper(slider, {
//     slidesPerView: 1,
//     loop: false,
//     navigation: {
//       nextEl: slider.querySelector('.button-next'),
//       prevEl: slider.querySelector('.button-prev'),
//     },
//     autoplay: false,
//   });
// });




document.addEventListener("DOMContentLoaded", function () {
  const cartBtns = document.querySelectorAll(".sp_cart_btn, .favoorite_btn");
  const variationCart = document.querySelector(".variation_cart");
  const closeBtn = document.querySelector(".variation_cart_close");
  const header = document.querySelector(".shopify-section--header");
  const body = document.querySelector("body");
  

  cartBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (variationCart) {
        body.classList.add("pop");
        variationCart.classList.add("active");
        header.classList.add("hidden");
      }
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      if (variationCart) {
        variationCart.classList.remove("active");
        header.classList.remove("hidden");
        body.classList.remove("pop");
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const vipBlock = document.querySelector('.vip-app-point-logs-block');
    const pointArea = document.querySelector('.point_area');

    if (vipBlock && pointArea) {
      const clone = vipBlock.cloneNode(true);
      pointArea.appendChild(clone);
    }
  }, 5000); // 5000ミリ秒 = 5秒
});


document.addEventListener('DOMContentLoaded', function () {
  const showMoreBtn = document.getElementById('show-more-orders');
  if (showMoreBtn) {
    showMoreBtn.addEventListener('click', function () {
      document.querySelectorAll('.order-item').forEach(el => el.style.display = 'block');
      this.style.display = 'none';
    });
  }

  const showMoreTableBtn = document.getElementById('show-more-orders-table');
  if (showMoreTableBtn) {
    showMoreTableBtn.addEventListener('click', function () {
      document.querySelectorAll('table .order-item').forEach(el => el.style.display = 'table-row');
      this.style.display = 'none';
    });
  }

  const showMoreTableBtn_sp = document.getElementById('show-more-orders-table_sp');
  if (showMoreTableBtn_sp) {
    showMoreTableBtn_sp.addEventListener('click', function () {
      document.querySelectorAll('.order_table_sp .order-item').forEach(el => el.style.display = 'table-row');
      this.style.display = 'none';
    });
  }
});

document.querySelectorAll('.child_click > span').forEach(span => {
  span.addEventListener('click', () => {
    const isActive = span.classList.contains('active');
    const nextDiv = span.nextElementSibling;

    document.querySelectorAll('.child_click > span').forEach(s => s.classList.remove('active'));
    document.querySelectorAll('.child_click > div').forEach(div => div.classList.remove('open'));

    if (!isActive) {
      span.classList.add('active');
      if (nextDiv && nextDiv.tagName.toLowerCase() === 'div') {
        nextDiv.classList.add('open');
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const target = document.querySelector('.sp_button');
  const fixedBtn = document.querySelector('.sp_cart_btn_fixed');

  let isBelowTarget = false;

  if (!target || !fixedBtn) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        isBelowTarget = false;
        fixedBtn.classList.remove('active');
      } else {
        const targetPosition = target.getBoundingClientRect().top + window.scrollY;
        if (window.scrollY > targetPosition) {
          isBelowTarget = true;
          fixedBtn.classList.add('active');
        }
      }
    },
    {
      root: null,
      threshold: 0
    }
  );

  observer.observe(target);
});


document.querySelectorAll('.swiper-custom').forEach((slider) => {
  const swiperInstance = new Swiper(slider, {
    slidesPerView: 1,
    loop: true,
    autoplay: false,
    effect: 'fade',
    speed: 1000,
    pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  });
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const linkListButtonLinks = document.querySelectorAll('.header-sidebar__linklist-button a[href="#"]');
  linkListButtonLinks.forEach(link => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
    });
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.header-sidebar__linklist-btn');

  buttons.forEach(button => {
    button.addEventListener('click', function() {
      const childList = this.nextElementSibling;

      if (this.classList.contains('active')) {
        // アクティブな場合は非表示にする
        this.classList.remove('active');
        childList.classList.remove('active');
        childList.style.maxHeight = '0';
      } else {
        // 非アクティブな場合は表示する

        // 他のアクティブなボタンと子要素を非表示にする (必要であれば)
        buttons.forEach(otherButton => {
          if (otherButton !== this && otherButton.classList.contains('active')) {
            otherButton.classList.remove('active');
            const otherChildList = otherButton.nextElementSibling;
            otherChildList.classList.remove('active');
            otherChildList.style.maxHeight = '0';
          }
        });

        this.classList.add('active');
        childList.classList.add('active');
        childList.style.maxHeight = childList.scrollHeight + 'px';
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // メディアクエリの定義 (PCのブレイクポイントに合わせる)
  const mediaQuery = window.matchMedia('(min-width: 900px)');

  function handleMediaQueryChange(e) {
    if (e.matches) {
      moveThumbnailSwatches();
    }
  }

  // 要素を移動させる関数を定義
  function moveThumbnailSwatches() {
    // すべての thumbnail-swatch 要素を取得
    const thumbnailSwatches = document.querySelectorAll('[id^="thumbnail-swatch--"]');

    thumbnailSwatches.forEach(thumbnailSwatch => {
      // thumbnail-swatch のIDから数字部分を抽出
      const idParts = thumbnailSwatch.id.split('--');
      if (idParts.length < 2) {
        return; // IDの形式が不正な場合はスキップ
      }
      const commonId = idParts[1]; // 例: "51312956703009"

      // 同じ数字部分を持つ variant__img 要素を検索
      const targetVariantImg = document.getElementById(`variant__img--${commonId}`);

      if (targetVariantImg) {
        // thumbnailSwatch 要素を targetVariantImg の直後に移動
        targetVariantImg.insertAdjacentElement('afterend', thumbnailSwatch);
      }
    });
  }

  // 初期ロード時にメディアクエリの状態をチェック
  handleMediaQueryChange(mediaQuery);

  // ウィンドウのリサイズ時にメディアクエリの状態が変更されたかを監視
  mediaQuery.addEventListener('change', handleMediaQueryChange);
});



document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".collection_header ul");
  let isDragging = false;
  let startX;
  let scrollLeft;

  function hasHorizontalScroll(el) {
    return el.scrollWidth > el.clientWidth;
  }
  function updateScrollClass() {
    if (hasHorizontalScroll(slider)) {
      slider.classList.add("has_scroll");
    } else {
      slider.classList.remove("has_scroll");
    }
  }
 
  updateScrollClass();
 
  window.addEventListener("resize", updateScrollClass);

  slider.addEventListener("mousedown", (e) => {
    if (!hasHorizontalScroll(slider)) return;
    isDragging = true;
    slider.classList.add("dragging");
    startX = e.pageX;
    scrollLeft = slider.scrollLeft;
    e.preventDefault(); 
  });

  document.addEventListener("mouseup", () => {
    isDragging = false;
    slider.classList.remove("dragging");
  });

  document.addEventListener("mousemove", (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX;
    const walk = (x - startX) * 2; // scroll speed
    slider.scrollLeft = scrollLeft - walk;
  });
});

// 10/22 商品ページ：カラー（color variations の画像・PC の色ごとの画像）を押すと、その色の画像をメインに出す
// SP のカートモーダルの中では動かさない（後ろのギャラリーが見えないため）
document.addEventListener("click", function (event) {
  const trigger = event.target.closest(".variation_image__wrap .variant-block[data-media-id], .variation_cart .variant-block[data-media-id] .variant__img");
  if (!trigger) return;
  if (trigger.closest(".variation_cart") && document.body.classList.contains("pop")) return;
  const block = trigger.closest(".variant-block[data-media-id]");
  const mediaId = block && block.dataset.mediaId;
  if (!mediaId) return;
  const gallery = document.querySelector("product-gallery");
  if (!gallery) return;
  const cells = Array.from(gallery.querySelectorAll(".product-gallery__media"));
  const index = cells.findIndex(function (cell) { return cell.getAttribute("data-media-id") === mediaId; });
  if (index < 0) return;
  const carousel = gallery.carousel;
  if (carousel && carousel.isScrollable && typeof carousel.select === "function") {
    carousel.select(index);
    // ギャラリーが画面の上に外れていたら、ギャラリーまで戻す
    if (gallery.getBoundingClientRect().top < 0) {
      gallery.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  } else {
    // 画像が縦に並ぶ表示のときは、その画像まで移動
    cells[index].scrollIntoView({ block: "start", behavior: "smooth" });
  }
});

// お気に入りページ（Wishlist King）：ブランド名と、発売前のボタン
// 商品ごとに /products/ハンドル?view=wk-brand（templates/product.wk-brand.liquid）から { brand, open } を取得する
// ・ブランド名：ベンダーではなくメタフィールド custom.brand の名前で .wk-vendor の表示を差し替える
// ・ボタン：発売前（custom._open が今より後）なら「COMING SOON」で押せなくする。発売後はアプリの表示のまま（カートへ追加／SOLD OUT）
//   （10/26 タグ「カミングスーン」での判定をやめた。アプリのコード編集側のタグ判定は外してもらう）
(() => {
  const data = {};    // ハンドル → { brand, open }（取得済み）
  const loading = {}; // ハンドル → 取得中
  const handleOf = (card) => {
    const link = card.querySelector("a[href*='/products/']");
    const m = link && link.getAttribute("href").match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  };
  const load = (handle) => {
    if (data[handle] || loading[handle]) return;
    loading[handle] = fetch(`/products/${handle}?view=wk-brand`)
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null)
      .then((j) => {
        data[handle] = j || { brand: null, open: null }; // 取得できなかったときはアプリの表示のまま
        apply();
      });
  };
  const apply = () => {
    document.querySelectorAll(".wk-product-card").forEach((card) => {
      const handle = handleOf(card);
      if (!handle) return;
      const d = data[handle];
      if (!d) return load(handle);

      const vendor = card.querySelector(".wk-vendor:not([data-brand])");
      if (vendor && d.brand !== null) {
        vendor.style.setProperty("--wk-brand-size", getComputedStyle(vendor).fontSize);
        vendor.setAttribute("data-brand", d.brand);
      }

      const comingSoon = d.open !== null && d.open * 1000 > Date.now();
      const btn = card.querySelector(".wk-cta-button");
      if (btn && comingSoon && !btn.hasAttribute("data-coming-soon")) {
        btn.setAttribute("data-coming-soon", "");
        btn.setAttribute("disabled", "");
      }
    });
  };
  // 念のため、発売前のボタンはクリックされてもカートに入れない
  document.addEventListener("click", (e) => {
    if (e.target.closest && e.target.closest(".wk-cta-button[data-coming-soon]")) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; apply(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  apply();
})();
